const VocabQRWithLogo = {
      cant_see: [
    "¿No puedes escanear el código? Visita:",
    "Can’t scan the code? Visit:"
  ],
      scan_me: [
    "Escanéame!",
    "Scan me!"
  ],
        qr_code: [
    "Código QR",
    "QR Code"
  ]

  }
  export default VocabQRWithLogo;
    